import type {
  TranslateNumberFormatOptions,
  TranslateNumberValue,
} from "./translate-number.type";

import { useGetProfileLocale } from "@/entities/current-user";

import { translateNumber } from "./translate-number.helper";

export const useTranslateNumber = () => {
  const locale = useGetProfileLocale();

  const _translateNumber = (
    value: TranslateNumberValue,
    formatOptions?: TranslateNumberFormatOptions
  ) => {
    return translateNumber(value, { locale, ...formatOptions });
  };

  return {
    translateNumber: _translateNumber,
  };
};
